/* Endorphi cart drawer extras: one-tap add (cross-sell) and pack upgrade.
   Uses event delegation because Dawn re-renders the drawer HTML after each change. */
(function () {
  if (window.__endorphiCart) return;
  window.__endorphiCart = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function drawer() { return document.querySelector('cart-drawer'); }
  function sectionIds() {
    var d = drawer();
    return d && d.getSectionsToRender ? d.getSectionsToRender().map(function (s) { return s.id; }) : ['cart-drawer', 'cart-icon-bubble'];
  }
  function post(url, body) {
    return fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok || j.status) throw j;
        return j;
      });
    });
  }
  function render(state) {
    var d = drawer();
    if (d && state && state.sections && d.renderContents) {
      d.classList.remove('is-empty');
      d.renderContents(state);
    }
    if (window.publish && window.PUB_SUB_EVENTS) {
      try { window.publish(PUB_SUB_EVENTS.cartUpdate, { source: 'endorphi-cart' }); } catch (e) {}
    }
  }
  function busy(btn, on) {
    if (!btn) return;
    btn.setAttribute('aria-busy', on ? 'true' : 'false');
    btn.disabled = !!on;
  }
  function showError(msg) {
    var box = document.getElementById('CartDrawer-CartErrors');
    if (box) box.textContent = msg || 'Sorry, something went wrong. Please try again.';
  }

  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-ec-add]');
    var up = e.target.closest('[data-ec-upgrade]');
    if (!add && !up) return;
    e.preventDefault();

    if (add) {
      busy(add, true);
      post('cart/add.js', { items: [{ id: Number(add.dataset.variantId), quantity: 1 }], sections: sectionIds(), sections_url: window.location.pathname })
        .then(render)
        .catch(function (err) { busy(add, false); showError(err && err.description); });
      return;
    }

    // Upgrade: add the 2-pack first, then remove the single, so nothing is lost if a step fails.
    busy(up, true);
    var item = { id: Number(up.dataset.variantId), quantity: 1 };
    if (up.dataset.sellingPlan) item.selling_plan = Number(up.dataset.sellingPlan);
    post('cart/add.js', { items: [item] })
      .then(function () {
        return post('cart/change.js', { id: up.dataset.lineKey, quantity: 0, sections: sectionIds(), sections_url: window.location.pathname });
      })
      .then(render)
      .catch(function (err) {
        busy(up, false);
        showError(err && err.description);
        // Refresh drawer so it always reflects the real cart
        fetch(root + '?sections=' + sectionIds().join(',')).then(function (r) { return r.json(); }).then(function (sections) { render({ sections: sections }); }).catch(function () {});
      });
  });
})();
